var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatchCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.342,
    height: 21.342,
    viewBox: "0 0 21.342 21.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "patch-check",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_163",
    "data-name": "Trazado 163",
    d: "M12.142,6.2a.667.667,0,0,1,0,.944l-4,4a.667.667,0,0,1-.944,0l-2-2A.668.668,0,0,1,6.139,8.2l1.529,1.53L11.2,6.2a.667.667,0,0,1,.944,0Z",
    transform: "translate(2.311 2.007)",
    fill: "#003082",
    stroke: "#0055b8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_164",
    "data-name": "Trazado 164",
    d: "M13.7,3.352,12.475,2.093l.954-.931.83.85L15.446,2a3.855,3.855,0,0,1,3.9,3.9l-.013,1.187.848.83a3.855,3.855,0,0,1,0,5.515l-.85.83.015,1.187a3.855,3.855,0,0,1-3.9,3.9l-1.187-.013-.83.848a3.855,3.855,0,0,1-5.515,0l-.83-.85L5.9,19.347a3.855,3.855,0,0,1-3.9-3.9l.013-1.187-.848-.83a3.855,3.855,0,0,1,0-5.515l.85-.83L2,5.9A3.855,3.855,0,0,1,5.9,2l1.187.013.83-.848a3.855,3.855,0,0,1,5.515,0l-.954.931a2.521,2.521,0,0,0-3.607,0L7.641,3.352,5.88,3.331A2.521,2.521,0,0,0,3.331,5.881L3.352,7.64,2.093,8.868a2.521,2.521,0,0,0,0,3.607L3.352,13.7l-.021,1.761a2.521,2.521,0,0,0,2.551,2.549l1.758-.021,1.229,1.259a2.521,2.521,0,0,0,3.607,0L13.7,17.991l1.761.021a2.521,2.521,0,0,0,2.549-2.551L17.991,13.7l1.259-1.229a2.521,2.521,0,0,0,0-3.607L17.991,7.641l.021-1.761a2.521,2.521,0,0,0-2.551-2.549L13.7,3.352Z",
    transform: "translate(-0.001 -0.001)",
    fill: "#003082"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatchCheck);
export default __webpack_public_path__ + "static/media/patch-check.7490c491bd83527c9f781aef7798691d.svg";
export { ForwardRef as ReactComponent };